import styled, { css } from 'styled-components';
import { FlexColumn } from '../../../styled/common';
import { Typography } from '../../ui/Typography';
import { Breakpoints } from '../../../styled/constants';

const headerHeight = '74px';

export const headerStyles = css`
  @media (min-width: ${Breakpoints.tablet}px) {
    display: none;
  }
`;

export const ItemCreationLayoutWrapper = styled.div<{
  $isFormStep?: boolean;
}>`
  @media (min-width: ${Breakpoints.tablet}px) {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100vh - ${headerHeight});
    background-color: ${({ theme }) => theme.colors.background.tertiary};
    padding: 60px 0 35px;
    position: relative;

    ${({ $isFormStep }) =>
      $isFormStep &&
      css`
        overflow: scroll;
        overflow-x: hidden;
        align-items: normal;
      `}
  }
`;

export const ItemCreationContentContainer = styled(FlexColumn)<{
  $isFormStep?: boolean;
  $isEditPage?: boolean;
}>`
  padding: 40px 20px 0;
  gap: 30px;

  ${({ $isFormStep, theme }) =>
    $isFormStep &&
    css`
      padding: 5px 0 40px;
      background-color: ${theme.colors.background.tertiary};
      height: 100%;
      overflow: scroll;
      gap: 10px;
    `}

  ${({ $isFormStep, $isEditPage }) =>
    $isFormStep &&
    $isEditPage &&
    css`
      padding-top: 0;
    `}

  &::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: ${Breakpoints.tablet}px) {
    width: 500px;
    padding: 60px 40px;
    background-color: ${({ theme: { colors } }) => colors.background.primary};
    border-radius: 14px;
    gap: 40px;

    ${({ $isEditPage }) =>
      $isEditPage &&
      css`
        gap: 30px;
      `}

    ${({ $isFormStep }) =>
      $isFormStep
        ? css`
            height: max-content;
            overflow: visible;
            margin-bottom: 80px;
          `
        : css`
            align-items: center;
          `}
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    width: 720px;
    padding: 60px;
  }
`;

export const ItemCreationContentTitle = styled(Typography)`
  display: none;

  @media (min-width: ${Breakpoints.tablet}px) {
    text-align: center;
    display: block;
  }
`;

export const LeftActionBlock = styled.div`
  position: absolute;
  left: 20px;
  border-top: 1px solid ${({ theme }) => theme.colors.border.primary};

  @media (min-width: ${Breakpoints.desktop}px) {
    left: 80px;
  }
`;
